import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LogInfoService } from 'src/app/services/panelM/log-info.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  standalone: false,
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.scss']
})
export class LogsComponent implements OnInit {

  logs = [];
  show = true;
  lo: any;
  dataLength = 0;
  displayedColumns: string[] = ['numero', 'Fecha', 'Maquina', 'Mensaje'];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private readonly router: Router, private logService: LogInfoService) {
  }

  ngOnInit() {
    this.logService.logInfoService().subscribe((data: any) => {
      this.dataLength = data.LogList.length;
      if (data && data.LogList) {
        this.show = false;
        this.lo = new MatTableDataSource<any>(this.replaceSimbols(data.LogList));
        this.lo.paginator = this.paginator;
      }
    }, (err) => {
      console.error(err);
      this.router.navigateByUrl('/portalM');
    });
  }

  private replaceSimbols(data: any) {
    let cont = 0;
    for (const item of data) {
      item.Mensaje = item.Mensaje.toLowerCase().replace(/&quot;/gi, '"');
      item.id = ++cont;
    }
    return data;
  }
}
